import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../utils/media'
import enterIcon from './enter.svg'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

export const PressEnterHint = () =>
  <Container>
    {lang === 'es' ? 'Presione enter para ir al siguiente campo' : 'Press Enter to go to the next field'} <EnterIcon src={enterIcon} />
  </Container>

const Container = styled.div`
  display: none;
  margin-top: 20px;
  font-family: "SF Pro Display";
  font-size: 12px;
  color: #979797;

  ${media.tablet`
    display: block;
  `}
`

const EnterIcon = styled.img`
  margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/molecules/PressEnterHint/index.tsx